import React, { Component } from 'react';
import { Input, Popup, Button, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { findDOMNode } from 'react-dom';

import { KeyboardCodeEnum } from 'Common/Constants/Enumeration/KeyboardCodeEnum';
import { NUMBER } from 'Common/FormHelper';
import { QuantityConstantsEnum } from 'Common/Constants/Enumeration/CommonEnum';

import 'Styles/components/editableLabel.less';

class EditableLabel extends Component {
  nameInput = React.createRef();
  state = {
    isEditableMode: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.isEditableMode !== this.state.isEditableMode &&
      this.state.isEditableMode
    ) {
      this.nameInput.current.focus();
    }
  }

  handleLabelClick = () => {
    this.setEditable(true);
  };

  handleValueChange = (event) => {
    const { onChange, refData, inputType } = this.props;
    let value = event.target.value;
    let defaultValue = event.target.defaultValue;
    if (value && inputType && NUMBER === inputType.toUpperCase()) {
      value = value.replace(/[^0-9]/, '');
    }
    if (onChange) {
      onChange.call(this, refData, value, defaultValue);
    }
  };

  handleInputBlur = (event) => {
    this.setEditable(false);
    const { onBlur, refData } = this.props;
    if (onBlur) {
      onBlur(refData);
    }
  };

  getNodeIndex = (node) => {
    let columnIndex = 0;
    let rowIndex = 0;
    if (node && _.hasIn(node, 'parentNode.parentNode.parentNode.parentNode')) {
      columnIndex = [
        ...node.parentNode.parentNode.parentElement.children,
      ].indexOf(node.parentNode.parentNode);
      rowIndex = [
        ...node.parentNode.parentNode.parentNode.parentNode.parentElement
          .children,
      ].indexOf(node.parentNode.parentNode.parentNode.parentNode);
    }
    return { columnIndex, rowIndex };
  };

  handleKeyUpForEnterAndEsc = (event) => {
    //Check for arrow key navigation
    if (
      [
        KeyboardCodeEnum.KEY_LEFT_ARROW,
        KeyboardCodeEnum.KEY_UP_ARROW,
        KeyboardCodeEnum.KEY_RIGHT_ARROW,
        KeyboardCodeEnum.KEY_DOWN_ARROW,
      ].includes(event.keyCode)
    ) {
      const node = this.nameInput;
      //Get current row and column index
      let nodeIndex = this.getNodeIndex(node.current.inputRef.current);
      const currentColumnIndex = nodeIndex['columnIndex'];
      const currentRowIndex = nodeIndex['rowIndex'];

      const parent = findDOMNode(this).closest('.ReactTable') || document;
      let elements = Array.prototype.slice.call(
        parent.querySelectorAll('div.rt-td input[type=text]')
      );

      //for right arrow
      if (event.keyCode === KeyboardCodeEnum.KEY_RIGHT_ARROW) {
        if (event.target.selectionStart === event.target.value.length) {
          for (let i in elements) {
            const node = elements[i];
            //Get row and column index
            let { columnIndex, rowIndex } = this.getNodeIndex(node);
            if (
              (columnIndex > currentColumnIndex &&
                rowIndex === currentRowIndex) ||
              rowIndex > currentRowIndex
            ) {
              node.focus();
              break;
            }
          }
        }
      }

      //for left arrow
      if (event.keyCode === KeyboardCodeEnum.KEY_LEFT_ARROW) {
        if (!event.target.selectionStart) {
          for (let i in elements.reverse()) {
            const node = elements[i];
            let { columnIndex, rowIndex } = this.getNodeIndex(node);
            if (
              (columnIndex < currentColumnIndex &&
                rowIndex === currentRowIndex) ||
              rowIndex < currentRowIndex
            ) {
              node.focus();
              break;
            }
          }
        }
      }

      //for up arrow
      if (event.keyCode === KeyboardCodeEnum.KEY_UP_ARROW) {
        for (let i in elements.reverse()) {
          const node = elements[i];
          let { columnIndex, rowIndex } = this.getNodeIndex(node);
          if (
            columnIndex === currentColumnIndex &&
            rowIndex < currentRowIndex
          ) {
            node.focus();
            break;
          }
        }
      }

      //for down arrow
      if (event.keyCode === KeyboardCodeEnum.KEY_DOWN_ARROW) {
        for (let i in elements) {
          const node = elements[i];
          let { columnIndex, rowIndex } = this.getNodeIndex(node);
          if (
            columnIndex === currentColumnIndex &&
            rowIndex > currentRowIndex
          ) {
            node.focus();
            break;
          }
        }
      }
    }

    if (
      event.keyCode === KeyboardCodeEnum.KEY_ESCAPE ||
      event.keyCode === KeyboardCodeEnum.KEY_ENTER
    ) {
      this.setEditable(false);
    }
  };

  setEditable = (value) => {
    this.setState({
      isEditableMode: value,
    });
  };

  onCalcClick = (dec) => {
    const { onChange, refData, inputType } = this.props;
    let value = dec;
    if (value && inputType && NUMBER === inputType.toUpperCase()) {
      value = value.replace(/[^0-9]/, '');
    }
    if (onChange) {
      onChange.call(this, refData, value.toString());
    }
  };
  render() {
    const { isEditableMode } = this.state;
    const {
      label,
      labelClassName,
      labelStyle,
      disabled,
      allowEdit,
      showCalc,
      className,
      disableInput, //use this flag, to disable input in pure react table grid

      //pull these out so they're not passed to Input
      refData,
      inputType,
      onBlur,
      onChange,
      ref,
      onKeyUp,
      ...inputProps
    } = this.props;
    const finalLabel = label ? (
      label
    ) : (
      <span dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
    );
    let renderHtml =
      !disabled && (isEditableMode || allowEdit) ? (
        <Input
          type="text"
          value={label}
          onBlur={(event) => this.handleInputBlur(event)}
          onChange={(event) => this.handleValueChange(event)}
          ref={this.nameInput}
          className={classNames('editable-input', className)}
          onKeyUp={(event) => this.handleKeyUpForEnterAndEsc(event)}
          disabled={disableInput}
          {...inputProps}
        />
      ) : (
        <div
          onClick={disabled ? () => {} : this.handleLabelClick}
          style={labelStyle ? labelStyle : { width: '100%' }}
          className={labelClassName}
        >
          {finalLabel}
        </div>
      );
    if (showCalc) {
      renderHtml = (
        <Popup
          trigger={renderHtml}
          on="focus"
          wide
          inverted
          position="top center"
          className="pop-up--container"
        >
          <Grid>
            <Grid.Row columns={5}>
              <Grid.Column verticalAlign={'middle'}>
                <label>One Quarter</label>
              </Grid.Column>
              <Grid.Column verticalAlign={'middle'}>
                <label>One Third</label>
              </Grid.Column>
              <Grid.Column verticalAlign={'middle'}>
                <label>One Half</label>
              </Grid.Column>
              <Grid.Column verticalAlign={'middle'}>
                <label>Two Thirds</label>
              </Grid.Column>
              <Grid.Column verticalAlign={'middle'}>
                <label>Three Quarters</label>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={5}>
              <Grid.Column verticalAlign={'top'}>
                <Button
                  type="button"
                  onClick={() =>
                    this.onCalcClick(QuantityConstantsEnum.OneQuarterNumeric)
                  }
                >
                  {QuantityConstantsEnum.OneQuarterRational}
                </Button>
              </Grid.Column>
              <Grid.Column verticalAlign={'top'}>
                <Button
                  type="button"
                  onClick={() =>
                    this.onCalcClick(QuantityConstantsEnum.OneThirdNumeric)
                  }
                >
                  {QuantityConstantsEnum.OneThirdRational}
                </Button>
              </Grid.Column>
              <Grid.Column verticalAlign={'top'}>
                <Button
                  type="button"
                  onClick={() =>
                    this.onCalcClick(QuantityConstantsEnum.OneHalfNumeric)
                  }
                >
                  {QuantityConstantsEnum.OneHalfRational}
                </Button>
              </Grid.Column>
              <Grid.Column verticalAlign={'top'}>
                <Button
                  type="button"
                  onClick={() =>
                    this.onCalcClick(QuantityConstantsEnum.TwoThirdsNumeric)
                  }
                >
                  {QuantityConstantsEnum.TwoThirdsRational}
                </Button>
              </Grid.Column>
              <Grid.Column verticalAlign={'top'}>
                <Button
                  type="button"
                  onClick={() =>
                    this.onCalcClick(QuantityConstantsEnum.ThreeQuartersNumeric)
                  }
                >
                  {QuantityConstantsEnum.ThreeQuartersRational}
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Popup>
      );
    }
    return renderHtml;
  }
}
EditableLabel.propTypes = {
  allowEdit: PropTypes.bool,
  disabled: PropTypes.bool,
  inputType: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  refData: PropTypes.object,
  showCalc: PropTypes.bool,
};
export default EditableLabel;



// WEBPACK FOOTER //
// ./src/components/editableLabel/EditableLabel.js